export const MESSAGE_TYPE_ID = '@type';
export const DATE_MESSAGE = 'DATE_MESSAGE';